import React, { useState } from 'react';

// Compact multi-select dropdown used for dashboard filters.
// Shows a single button trigger; clicking opens a checkbox list.
// onChange(newArray) called on every toggle.
export default function MultiSelectDropdown({
  label,
  options,              // [{ value, label }]
  selected,             // array of values
  onChange,
  placeholder = 'All',
  testId = 'multi-select',
  width = 180,
}) {
  const [open, setOpen] = useState(false);

  const toggle = (val) => {
    if (selected.includes(val)) onChange(selected.filter((x) => x !== val));
    else onChange([...selected, val]);
  };

  const active = selected.length > 0 && selected.length < options.length;
  const triggerText = selected.length === 0 || selected.length === options.length
    ? placeholder
    : `${selected.length} of ${options.length}`;

  return (
    <div className="flex flex-col gap-1">
      <span className="overline">{label}</span>
      <div className="relative" style={{ width }}>
        <button
          className={`btn-secondary w-full justify-between ${active ? 'border-[hsl(var(--primary))] text-[hsl(var(--primary))]' : ''}`}
          onClick={() => setOpen((o) => !o)}
          data-testid={`${testId}-trigger`}
        >
          <span className="font-heading font-semibold text-[13px] truncate">{triggerText}</span>
          <svg width="10" height="10" viewBox="0 0 10 10"><path d="M1 3l4 4 4-4" stroke="currentColor" strokeWidth="1.5" fill="none" /></svg>
        </button>
        {open && (
          <>
            <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
            <div
              className="absolute z-40 mt-1 left-0 min-w-full bg-white border border-border shadow-[0_8px_24px_rgba(0,0,0,0.08)] max-h-[260px] overflow-y-auto"
              data-testid={`${testId}-menu`}
            >
              <div className="px-2 py-1 border-b border-border flex items-center justify-between gap-2">
                <button
                  className="text-[11px] font-mono text-[#575757] hover:text-[hsl(var(--primary))]"
                  onClick={() => onChange(options.map((o) => o.value))}
                  data-testid={`${testId}-select-all`}
                >
                  Select all
                </button>
                <button
                  className="text-[11px] font-mono text-[#575757] hover:text-[hsl(var(--destructive))]"
                  onClick={() => onChange([])}
                  data-testid={`${testId}-clear`}
                >
                  Clear
                </button>
              </div>
              {options.map((o) => {
                const checked = selected.includes(o.value);
                return (
                  <button
                    key={o.value}
                    onClick={() => toggle(o.value)}
                    className={`w-full text-left px-3 py-1.5 flex items-center gap-2 border-b border-border last:border-b-0 text-[12px] hover:bg-[#EFEFEA] ${checked ? 'bg-[#F1F6F2]' : ''}`}
                    data-testid={`${testId}-option-${o.value}`}
                  >
                    <span className={`w-3.5 h-3.5 rounded-[2px] border ${checked ? 'bg-[hsl(var(--primary))] border-[hsl(var(--primary))]' : 'border-[#B0B0A8]'}  flex items-center justify-center`}>
                      {checked && (
                        <svg width="9" height="9" viewBox="0 0 10 10" fill="none">
                          <path d="M2 5l2 2 4-4" stroke="white" strokeWidth="1.6" />
                        </svg>
                      )}
                    </span>
                    <span className="flex-1 truncate">{o.label}</span>
                  </button>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
